import React, { useContext } from "react";
import { COVERAGE_FORM, COVERAGE_NAMES } from "@platform/rfp-core";

import { BenchmarkSection, CommissionSection } from "../../components";
import { RFP_ACTION_TYPES } from "../../constants";
import { RfpContext } from "../../contexts/rfpContext";
import CoverageButtonWrapper from "../components/coverageButtonWrapper";
import envVariables from "../../../../projectEnvVariables";
import CommentsField from "../components/commentsField";

import { createValidationHandlers } from "./coveragesValidations";

const {
  COMMENTS,
  CURRENT_COMMISSION,
  REQUESTED_COMMISSION,
  PLAN_TYPE,
  SINGLE_PLAN,
  PLANS,
  NO_PLAN,
} = COVERAGE_FORM;
const { UPDATE_SELECTED_COVERAGE } = RFP_ACTION_TYPES;
const { ACCIDENT, CANCER, CI, HOSPITAL } = COVERAGE_NAMES;

export const initialAccidentCoveragesDetails = {
  [PLAN_TYPE]: SINGLE_PLAN,
  [PLANS]: [
    {
      [CURRENT_COMMISSION]: "",
      [REQUESTED_COMMISSION]: "",
      [COMMENTS]: "",
      name: SINGLE_PLAN,
    },
  ],
};

const Accident = ({
  coverage,
  handleNext,
  isLastCoverage,
  nextCoverage,
  handleBack,
  prevCoverage,
  isFirstCoverage,
}) => {
  const { setRfp } = useContext(RfpContext);

  const handleFormChange = (updatedCoverage, currentPlanKey, fieldKey) => {
    setRfp({
      type: UPDATE_SELECTED_COVERAGE,
      value: updatedCoverage,
      currentPlanKey,
      fieldKey,
    });
  };

  return (
    <>
      <AccidentForm coverage={coverage} onFormChange={handleFormChange} />
      <CoverageButtonWrapper
        displayBackButton={!isFirstCoverage}
        displayNextButton={!isLastCoverage}
        backButtonName={prevCoverage?.name}
        nextButtonName={nextCoverage?.name}
        handleBackAction={handleBack}
        handleNextAction={handleNext}
      />
    </>
  );
};

export const AccidentForm = ({ coverage, onFormChange }) => {
  const isCurrentCoverage = coverage?.isCurrentCoverage;
  const currentPlan = coverage?.details[PLANS][0];
  const currentPlanErrors = currentPlan.errors || {};
  const displayBenchmarks = [ACCIDENT, CI, HOSPITAL, CANCER].includes(
    coverage?.name,
  );

  const handlePlanFormChange = ({ name, value }) => {
    const localPlan = {
      ...currentPlan,
      [name]: value,
      displayName: NO_PLAN,
    };
    const payload = {
      ...coverage,
      details: { ...coverage.details, [PLANS]: [localPlan] },
    };
    onFormChange(payload, 0, name);
  };

  const { handlePlanFormChangeWithValidation, handlePreviousFieldsValidation } =
    createValidationHandlers({
      currentPlan,
      coverage,
      onFormChange,
      isCurrentCoverage,
      activeTab: 0,
      planName: null,
    });

  const benchmarksUrl = () => {
    switch (coverage?.name) {
      case ACCIDENT:
        return envVariables.VITE_REACT_APP_ACCIDENT_BENCHMARKS_URL;
      case CANCER:
        return envVariables.VITE_REACT_APP_CANCER_BENCHMARKS_URL;
      case CI:
        return envVariables.VITE_REACT_APP_CRITICAL_ILLNESS_BENCHMARKS_URL;
      case HOSPITAL:
        return envVariables.VITE_REACT_APP_HOSPITAL_BENCHMARKS_URL;
      default:
        return "/";
    }
  };

  return (
    <>
      <CommissionSection
        handlePlanFormChange={handlePlanFormChange}
        handlePlanFormChangeWithValidation={handlePlanFormChangeWithValidation}
        handlePreviousFieldsValidation={handlePreviousFieldsValidation}
        currentPlanErrors={currentPlanErrors}
        currentPlan={currentPlan}
        isCurrentCoverage={isCurrentCoverage}
      />

      {!isCurrentCoverage && displayBenchmarks && (
        <BenchmarkSection
          handlePlanFormChange={handlePlanFormChange}
          currentPlan={currentPlan}
          link={benchmarksUrl()}
          coverageName={coverage?.name}
        />
      )}

      <CommentsField
        currentPlan={currentPlan}
        onChange={(e) => {
          handlePlanFormChange(e.target);
        }}
        handlePreviousFieldsValidation={handlePreviousFieldsValidation}
      />
    </>
  );
};

export default Accident;
